import { z } from 'zod'

export const SearchSchema = z.object({
  continentId: z.number().optional(),
  isHot: z.number().max(1).optional(),
  showOnContinentHomepage: z.number().max(1).optional(),
  status: z.number().max(1).optional(),
  page: z.number().default(1),
  size: z.number().default(10),
})

export type Search = z.infer<typeof SearchSchema>
